export * from './lib/icons.component';

